/**
 * Navigation Service
 * Stores the navigate function from react-router so we don't need to pass it everywhere
 * This is initialized once in the app root
 */
class NavigationService {
  constructor() {
    this.navigate = null;
    this.location = null;
  }

  /**
   * Initialize the service with react-router's navigate function
   * Should be called once in App component or root
   */
  init(navigate, location) {
    this.navigate = navigate;
    this.location = location;
  }

  /**
   * Get the navigate function
   */
  getNavigate() {
    if (!this.navigate) {
      console.error('NavigationService not initialized. Call init() in your App component.');
      return () => {};
    }
    return this.navigate;
  }

  /**
   * Get current location
   */
  getLocation() {
    return this.location;
  }

  /**
   * Navigate to a path
   */
  navigateTo(path, options = {}) {
    const nav = this.getNavigate();
    return nav(path, options);
  }

  /**
   * Go back
   */
  goBack() {
    const nav = this.getNavigate();
    return nav(-1);
  }

  /**
   * Go forward
   */
  goForward() {
    const nav = this.getNavigate();
    return nav(1);
  }
}

// Singleton instance
const navigationService = new NavigationService();

export default navigationService;
